import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LoadingReport } from '@/components/LoadingReport/LoadingReport'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'

export const GeneratingReportMock = () => {
  const navigate = useNavigate()
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressInterval)
          return 100
        }
        return prev + 2 // 2% each 100ms to reach 100% in 5 seconds
      })
    }, 100)

    const redirectTimeout = setTimeout(() => {
      navigate(AppRoutes.paymentPaywall)
    }, 5000)

    return () => {
      clearInterval(progressInterval)
      clearTimeout(redirectTimeout)
    }
  }, [navigate])

  return (
    <WeScreen useHeader={false}>
      <LoadingReport progress={progress} />
    </WeScreen>
  )
}
